import StoreRules from './StoreRules';

export default (props) => {
  return <StoreRules {...props} />;
};
